// @ts-nocheck
import borrarFicha from "@assets/images/lottery-icons/fichas/borrar-ficha.svg";
import useCurrencyStore from "@store/useCurrency.store";
import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {BaseButton} from "@/components";

import {fichas, MAX_TOTAL_BET} from "./ticketsboard.consts";
import {TicketsBoardPropTypes} from "./ticketsboard.proptypes";
import {createTimeSlots} from "./ticketsboard.utils";

const ticketsBoardContainerCls =
  "w-full max-w-[var(--size-100)] flex flex-col bg-[var(--color-surface-2)] rounded-[var(--radius-xl)] p-4 overflow-hidden h-auto gap-3 border border-[rgba(255,255,255,0.07)] shadow-[0_8px_32px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.06)]";
const topButtonsCls = "flex flex-col gap-2";
const totalAmountCls =
  "w-full rounded-[var(--radius-lg)] px-3 pt-3 pb-2 bg-[rgba(0,0,0,0.25)] border border-[rgba(255,255,255,0.07)] flex flex-col gap-1.5 max-md:w-[calc(100%-30px)] max-md:mx-auto";
const titleCls = "m-0 text-[10px] font-bold uppercase tracking-widest text-[var(--color-text-tertiary)] text-center";
const totalInfoCls = "flex flex-col items-center w-full gap-1.5";
const amountDisplayCls =
  "w-full flex items-center justify-center py-1";
const amountTextCls = "text-[var(--color-primary)] text-[1.75rem] font-extrabold leading-none m-0 drop-shadow-[0_0_16px_rgba(253,238,51,0.35)] [&_span]:font-extrabold";
const clearBetsBtnCls =
  "w-full h-7 bg-transparent text-[var(--color-text-tertiary)] cursor-pointer flex items-center justify-center text-[10px] font-semibold border-0 border-t border-[rgba(255,255,255,0.07)] pt-1.5 mt-0.5 transition-colors duration-200 hover:text-[var(--color-danger-text)]";
const warningTextCls =
  "text-(length:--font-caption) text-[var(--color-lottery-board-orange-from)] font-semibold text-center whitespace-nowrap";
const maxReachedTextCls =
  "text-(length:--font-caption) text-[var(--color-danger)] font-bold text-center whitespace-nowrap";
const timeSelectionCls =
  "rounded-[var(--radius-lg)] bg-[rgba(0,0,0,0.25)] border border-[rgba(255,255,255,0.07)] p-3 flex flex-col gap-2 max-md:w-[calc(100%-30px)] max-md:mx-auto";
const titleBoxCls =
  "flex flex-col justify-center items-center w-full [&_h3]:text-(length:--font-body) [&_h3]:font-bold [&_h3]:text-[var(--color-text)] [&_h3]:m-0 [&_h3]:leading-tight [&_p]:text-[10px] [&_p]:font-normal [&_p]:text-center [&_p]:text-[var(--color-text-tertiary)] [&_p]:m-0 [&_p]:mt-0.5";
const timeSlotsGridCls = "grid grid-cols-3 gap-1.5 items-center";
const timeSlotBtnCls =
  "w-full h-8 rounded-full border border-[rgba(255,255,255,0.12)] p-0 bg-transparent text-[var(--color-text-secondary)] text-[11px] font-semibold cursor-pointer transition-all duration-150 flex items-center justify-center hover:border-[var(--color-accent-magenta)] hover:text-[var(--color-accent-magenta)] hover:bg-[rgba(215,50,168,0.08)]";
const timeSlotBtnSelectedCls = "!border-[var(--color-accent-magenta)] !text-white !bg-[linear-gradient(135deg,rgba(250,84,0,0.85)_0%,rgba(215,50,168,0.85)_100%)] !shadow-[0_2px_12px_rgba(215,50,168,0.4)]";
const timeSlotBtnDisabledCls =
  "!opacity-25 !cursor-not-allowed hover:!border-[rgba(255,255,255,0.12)] hover:!text-[var(--color-text-secondary)] hover:!bg-transparent hover:!shadow-none";
const fichasContainerCls =
  "w-full rounded-[var(--radius-lg)] bg-[rgba(0,0,0,0.25)] border border-[rgba(255,255,255,0.07)] p-3 max-md:w-[calc(100%-30px)] max-md:mx-auto";
const fichasGridCls = "grid grid-cols-3 gap-2.5 auto-rows-auto";
const fichaBtnCls =
  "w-full h-auto border-0 bg-transparent cursor-pointer p-0 transition-all duration-200 flex items-center justify-center hover:scale-105 relative";
const fichaSelectedCls =
  "!border-[3px] !border-solid !border-[var(--color-primary)] !rounded-full !shadow-[0_0_18px_rgba(253,238,51,0.55)] !bg-transparent [&_img]:border-[3px] [&_img]:border-solid [&_img]:border-[var(--color-primary)]";
const fichaDisabledCls = "!opacity-50 !cursor-not-allowed hover:!scale-100";
const deletionModeActiveCls =
  "!bg-[var(--color-lottery-board-red)] !rounded-full !border-[3px] !border-solid !border-[var(--color-sports-glow-to)] !shadow-[0_0_20px_rgba(255,0,0,0.6)] animate-pulse hover:!bg-[var(--color-danger-soft)] hover:!scale-110";
const fichaImageCls = "w-full h-full rounded-full cursor-pointer transition-all duration-200 object-cover";
const deletionModeIndicatorCls =
  "absolute -bottom-5 left-1/2 -translate-x-1/2 bg-[var(--color-sports-glow-to)] text-white px-2 py-0.5 rounded-[var(--radius-lg)] text-(length:--font-eyebrow) font-bold whitespace-nowrap animate-pulse";

export const TicketsBoard = ({
  totalAmount = 0,
  onClearBets,
  onFichaSelect,
  selectedFicha,
  onTimeSelect,
  selectedTime,
  onBuyTicket,
  placedBets = [],
  sorteos = [],
  isDeletionMode = false,
  hideChips = false, // New prop to hide chip selection
}) => {
  const navigate = useNavigate();
  const containerRef = useRef(null);

  const selectedCurrency = useCurrencyStore(state => state.selectedCurrency);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const clearStyles = () => {
      if (container) {
        container.style.position = "";
        container.style.top = "";
        container.style.left = "";
        container.style.width = "";
        container.style.zIndex = "";
      }
    };

    const updatePosition = () => {
      const isDesktop = window.innerWidth >= 769;

      if (!isDesktop) {
        clearStyles();
        return;
      }

      const ticketsBoardContainer = container.parentElement;
      if (!ticketsBoardContainer) return;

      const lotteryLayout = container.closest('[class*="lotteryLayout"]');
      if (!lotteryLayout) return;

      const viewportHeight = window.innerHeight;
      const containerHeight = container.offsetHeight;
      const lotteryLayoutRect = lotteryLayout.getBoundingClientRect();
      const ticketsBoardContainerRect = ticketsBoardContainer.getBoundingClientRect();

      const centerY = viewportHeight / 2;
      const targetTop = centerY - containerHeight / 2;

      const minTop = lotteryLayoutRect.top;
      const maxTop = lotteryLayoutRect.bottom - containerHeight;
      const finalTop = Math.max(minTop, Math.min(targetTop, maxTop));

      const ticketsBoardLeft = lotteryLayoutRect.left;
      const ticketsBoardWidth = ticketsBoardContainerRect.width;

      container.style.position = "fixed";
      container.style.top = `${finalTop}px`;
      container.style.left = `${ticketsBoardLeft}px`;
      container.style.width = `${ticketsBoardWidth}px`;
      container.style.zIndex = "10";
    };

    const isDesktop = window.innerWidth >= 769;

    if (isDesktop) {
      const timeoutId = setTimeout(updatePosition, 100);
      window.addEventListener("scroll", updatePosition);
      window.addEventListener("resize", updatePosition);

      return () => {
        clearTimeout(timeoutId);
        window.removeEventListener("scroll", updatePosition);
        window.removeEventListener("resize", updatePosition);
        clearStyles();
      };
    } else {
      clearStyles();

      window.addEventListener("resize", updatePosition);
      return () => {
        window.removeEventListener("resize", updatePosition);
        clearStyles();
      };
    }
  }, []);

  const timeSlots = createTimeSlots(sorteos);

  const handleTimeSlotClick = timeObj => {
    if (onTimeSelect) {
      onTimeSelect(timeObj.originalTime, timeObj.sorteoId);
    }
  };

  const handleFichaClick = ficha => {
    if (onFichaSelect) {
      onFichaSelect(ficha);
    }
  };

  return (
    <div
      ref={containerRef}
      className={ticketsBoardContainerCls}
    >
      <div className={topButtonsCls}>
        <BaseButton
          variant="secondary"
          className="!h-8 !rounded-full !border !border-[rgba(255,255,255,0.15)] !bg-transparent !text-[var(--color-text-tertiary)] !text-xs !font-medium hover:!border-[rgba(255,255,255,0.3)] hover:!text-[var(--color-text-secondary)]"
          onClick={() => navigate("/lottery/tickets")}
        >
          Mis Tickets
        </BaseButton>
        <BaseButton
          variant="primary"
          className="!h-12 !rounded-full !border-0 !font-extrabold !text-base !text-white !bg-[linear-gradient(90deg,rgba(250,84,0,1)_0%,rgba(215,50,168,1)_100%)] !shadow-[0_4px_20px_rgba(215,50,168,0.45)] hover:!opacity-90 hover:!shadow-[0_6px_28px_rgba(215,50,168,0.6)] active:!scale-[0.98]"
          onClick={onBuyTicket}
        >
          Comprar Ticket
        </BaseButton>
      </div>

      <div className={totalAmountCls}>
        <p className={titleCls}>Monto de apuesta:</p>
        <div className={totalInfoCls}>
          <div className={amountDisplayCls}>
            <p className={amountTextCls}>
              {`${selectedCurrency?.symbol || ""}`}
              <span> {totalAmount}</span>
            </p>
          </div>

          <button
            type="button"
            className={clearBetsBtnCls}
            onClick={onClearBets}
            title="Limpiar"
          >
            Limpiar Apuestas
          </button>
        </div>
        <div>
          {totalAmount >= MAX_TOTAL_BET * 0.9 && totalAmount < MAX_TOTAL_BET && (
            <div className={warningTextCls}>
              Límite máximo ({selectedCurrency?.symbol || ""}
              {MAX_TOTAL_BET})
            </div>
          )}
          {totalAmount >= MAX_TOTAL_BET && <div className={maxReachedTextCls}>Límite máximo alcanzado</div>}
        </div>
      </div>

      {/* Hide chip selection when hideChips is true */}
      {!hideChips && (
        <div className={fichasContainerCls}>
          <div className={fichasGridCls}>
            {fichas.map(ficha => (
              <button
                key={ficha.value}
                type="button"
                className={`${fichaBtnCls} ${selectedFicha?.value === ficha.value ? fichaSelectedCls : ""}`}
                onClick={() => handleFichaClick(ficha)}
              >
                <img
                  src={ficha.image}
                  alt={`Ficha ${ficha.value}`}
                  className={fichaImageCls}
                />
              </button>
            ))}

            <button
              type="button"
              className={`${fichaBtnCls} ${
                placedBets.length === 0 ? fichaDisabledCls : ""
              } ${isDeletionMode ? deletionModeActiveCls : ""}`}
              onClick={() => handleFichaClick(null)}
              disabled={placedBets.length === 0}
              title={
                isDeletionMode
                  ? "Cancelar modo borrar"
                  : placedBets.length === 0
                    ? "No hay fichas para borrar"
                    : "Activar modo borrar"
              }
            >
              <img
                src={borrarFicha}
                alt="Borrar ficha"
              />
              {isDeletionMode && <div className={deletionModeIndicatorCls}>BORRAR</div>}
            </button>
          </div>
        </div>
      )}

      <div className={timeSelectionCls}>
        <div className={titleBoxCls}>
          <h3>Hora de sorteo</h3>
          <p>Selecciona la hora de tu apuesta</p>
        </div>
        {timeSlots.length === 0 ? (
          <div
            style={{
              textAlign: "center",
              color: "white",
              fontSize: "var(--font-body)",
            }}
          >
            No hay sorteos disponibles
          </div>
        ) : (
          <div className={timeSlotsGridCls}>
            {timeSlots.map(draw => {
              const isSelected = selectedTime === draw.originalTime;
              return (
                <button
                  key={draw.originalTime}
                  type="button"
                  className={`${timeSlotBtnCls} ${draw.isPassed ? timeSlotBtnDisabledCls : ""} ${isSelected ? timeSlotBtnSelectedCls : ""}`}
                  onClick={() => !draw.isPassed && handleTimeSlotClick(draw)}
                  disabled={draw.isPassed}
                >
                  {draw.displayTime}
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

TicketsBoard.propTypes = TicketsBoardPropTypes;
